<template>
  <b-modal
    :id="modalId"
    :title="modalTitle"
    ok-title="Guardar"
    cancel-title="Cancelar"
    @ok="handleSubmit"
    @hidden="resetForm"
  >
    <b-form @submit.prevent="handleSubmit">
      <b-form-group label="Código de la Sección">
        <b-form-input
          v-model="form.codigo"
          placeholder="Ej: A"
          required
        />
      </b-form-group>
      <b-form-group label="Estado" class="mt-1">
        <b-form-select
          v-model="form.estado"
          :options="statusOptions"
          required
        />
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { BModal, BForm, BFormGroup, BFormInput, BFormSelect } from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
  },
  props: {
    sectionData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalId: 'section-modal',
      form: {
        seccionId: null,
        codigo: '',
        estado: true,
      },
      statusOptions: [
        { text: 'Activo', value: true },
        { text: 'Inactivo', value: false }
      ],
    }
  },
  computed: {
    modalTitle() {
      return this.form.seccionId ? 'Editar Sección' : 'Nueva Sección'
    },
  },
  watch: {
    sectionData(newData) {
      if (newData) {
        this.form = { ...newData }
      } else {
        this.resetForm()
      }
    },
  },
  methods: {
    handleSubmit() {
      this.$emit('submit', { ...this.form })
      this.$bvModal.hide(this.modalId)
    },
    resetForm() {
      this.form = {
        seccionId: null,
        codigo: '',
        estado: true,
      }
    },
  },
}
</script>
